export const convertLabelToId = (label: string): string => {
  return label.toLowerCase().replace(/ /g, '-');
};
